// extracted by mini-css-extract-plugin
export var arrow = "search-item-module--arrow--8VkmS";
export var container = "search-item-module--container--5r0Wh";
export var contentParagraph = "search-item-module--content-paragraph--gIw1m";
export var img = "search-item-module--img--I26g7";
export var imgBox = "search-item-module--img-box---d7ME";
export var imgWrapper = "search-item-module--img-wrapper--DEvmz";
export var ratio = "search-item-module--ratio--DJpFC";
export var title = "search-item-module--title--tyVlJ";